var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.789 2.36397C20.3802 2.44223 21.6207 3.74655 21.6414 5.31793L21.638 5.50771L21.3271 11.829C21.2942 12.4984 21.0382 13.1353 20.6035 13.6398L20.452 13.803L12.4921 21.7629C11.3623 22.8926 9.55576 22.933 8.37768 21.884L8.24944 21.7629L2.23903 15.7525C1.1093 14.6228 1.06895 12.8162 2.11799 11.6381L2.23903 11.5099L10.199 3.54991C10.6729 3.076 11.2902 2.77596 11.9512 2.69403L12.1729 2.67486L18.4942 2.36397C18.5924 2.35914 18.6908 2.35914 18.789 2.36397ZM18.6907 4.36156H18.5925L12.2712 4.67244C12.0646 4.6826 11.8673 4.7565 11.7057 4.88242L11.6132 4.96413L3.65324 12.9241C3.29062 13.2867 3.26471 13.8586 3.57554 14.2511L3.65324 14.3383L9.66365 20.3487C10.0263 20.7113 10.5981 20.7372 10.9906 20.4264L11.0779 20.3487L19.0378 12.3887C19.1841 12.2425 19.2807 12.0552 19.3159 11.8534L19.3295 11.7308L19.6404 5.40947C19.6675 4.85785 19.2423 4.38869 18.6907 4.36156ZM17.9115 6.09045C18.8878 7.06676 18.8878 8.64968 17.9115 9.62599C16.9352 10.6023 15.3523 10.6023 14.376 9.62599C13.3997 8.64968 13.3997 7.06676 14.376 6.09045C15.3523 5.11414 16.9352 5.11414 17.9115 6.09045ZM15.7902 7.50467C15.5949 7.69993 15.5949 8.01651 15.7902 8.21177C15.9854 8.40704 16.302 8.40704 16.4973 8.21177C16.6925 8.01651 16.6925 7.69993 16.4973 7.50467C16.302 7.3094 15.9854 7.3094 15.7902 7.50467Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconTag.a7d347d39a1a71b18394c7b4038d6bd5.svg";